import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';
import { BasicTextInputComponent } from '../basic-text-input/basic-text-input.component';
import { SelectBasicComponent } from '../select-basic/select-basic.component';
import { CheckboxBasicComponent } from '../basic-checkbox/basic-checkbox.component';

import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
import { CoverpathControllerInterface } from '../../../../interfaces/controller/CoverpathControllerInterface';
import { TextAutoCompleteDropDownComponent } from '../text-autocomplete-dropdown/text-autocomplete-dropdown.component';

@Component({
  moduleId: module.id,
  selector: 'custom-drivers-license',
  templateUrl: './custom-drivers-license.component.html',
})
export class CustomDriversLicenseComponent extends BaseFormComponent implements OnInit {
  @ViewChild('licenseNumber', { static: true }) licenseNumber: BasicTextInputComponent;
  @ViewChild('licenseState', { static: true }) licenseState: SelectBasicComponent | TextAutoCompleteDropDownComponent;
  @ViewChild('licenseExpirationDate', { static: true }) licenseExpirationDate: BasicTextInputComponent;
  @ViewChild('noDriversLicense', { static: true }) noDriversLicense: CheckboxBasicComponent;
  controller: CoverpathControllerInterface;
  insuredType: string;
  @Input() mask = {
    guide: true,
    mask: [/^([0-1])/, /\d/, '/', /^(0|1|2|3)/, /\d/, '/', /^(1|2)/, /^(9|0|1)/, /\d/, /\d/],
    placeholder: 'MM/DD/YYYY',
  };
  is2020CoverpathOrMMD: boolean;

  constructor(protected injector: Injector, private amorphicService: AmorphicService) {
    super(injector);

    this.controller = this.amorphicService.controller;
    this.questionItem = this.injector.get('questionItem');

    this.is2020CoverpathOrMMD = this.controller.customer.application.primaryPolicy.is2020CoverpathOrMMD();
  }

  async ngOnInit() {
    super.ngOnInit();

    this.noDriversLicense.inputText =
      !this.controller.customer.application.primaryPolicy.insured.person.hasDriversLicense;

    this.obfuscationProperty = {
      type: 'IdNumber',
      prop: 'customer.application.primaryPolicy.insured.person.idNumber',
      shouldObfuscate: true,
    }; //prop value is hard coded here because this.prop or this.licenseNumber.prop is not always idNumber
    await this.setupPiiDisplay();
  }

  trigger(): void {
    if (this.noDriversLicense.inputText) {
      // make sure idType is not still 'drivers' if insured checks no driver's license
      this.controller.customer.application.primaryPolicy.insured.person.idType = undefined;
      this.clearFields();
    } else {
      this.controller.customer.application.primaryPolicy.insured.person.idType = 'drivers';
    }

    this.controller.customer.application.primaryPolicy.insured.person.hasDriversLicense =
      !this.noDriversLicense.inputText;
  }

  resetValue(): void {
    this.clearFields();
    this.noDriversLicense.inputText = false;
  }

  clearFields(): void {
    this.licenseNumber.resetValue();
    this.licenseNumber.clearErrorMessage(true);
    this.licenseNumber.shouldObfuscate = false;
    this.licenseState.resetValue();
    this.licenseState.clearErrorMessage(true);
    this.licenseExpirationDate.resetValue();
    this.licenseExpirationDate.clearErrorMessage(true);
  }

  updateFromModel(): void {}

  async setupPiiDisplay(): Promise<void> {
    const propValue = this.licenseNumber.getValue(this.obfuscationProperty.prop);
    if (propValue) {
      const piiValue: string = await this.piiService.getPiiValueByKey(propValue, this.obfuscationProperty);
      this.licenseNumber.obfuscationPattern = this.getObfuscationPattern(piiValue);
      await super.setupPiiDisplay(this.licenseNumber);
    } else {
      this.shouldObfuscate = false;
    }
  }

  async showLicenseNumber() {
    if (this.licenseNumber.isError) {
      this.licenseNumber.shouldObfuscate = false;
    } else {
      await super.showPii(this.licenseNumber);
    }
  }

  async obfuscateLicenseNumber() {
    this.licenseNumber.obfuscationPattern = this.getObfuscationPattern();
    if (!this.licenseNumber.val || this.licenseNumber.isError) {
      this.licenseNumber.shouldObfuscate = false;
    } else {
      super.obfuscatePii(this.licenseNumber);
    }
  }

  private getObfuscationPattern(val?: string): string {
    if (val) {
      return '•'.repeat(val.length);
    } else {
      return this.licenseNumber.val ? '•'.repeat(this.licenseNumber.val.length) : '';
    }
  }
}
